export const ActionDidNotRevalidate = 0;
export const ActionDidRevalidateStaticAndDynamic = 1;
export const ActionDidRevalidateDynamicOnly = 2;

//# sourceMappingURL=action-revalidation-kind.js.map